/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import Zone from 'galax/server/zone';


export default class
{
  constructor (parent, collection)
  {
    this.parent = parent;

    this.zones = new Map();
    this.platforms = new Map();

    for (const zone of collection.values())
    {
      this.zones.set(zone.id, new Zone(zone, this.parent.getSectors().getOne(zone.sector)));
    }
  }


  setupInstaller (installer)
  {
    for (const zone of this.zones.values())
    {
      installer.getZoneSetupQueue().push(zone);
      installer.getZoneInstallQueue().push(zone);
      installer.getZoneInfluenceQueue().push(zone);
    }
  }


  insertZone (zone)
  {
    this.zones.set(zone.getLocation().getID(), zone);
  }


  insertPlatform (zone)
  {
    this.platforms.set(zone.getLocation().getID(), zone);
  }


  getZone (coords)
  {
    return this.zones.get(coords.toString());
  }


  getPlatform (coords)
  {
    return this.platforms.get(coords.toString());
  }


  getZones ()
  {
    return this.zones.values();
  }


  getPlatforms ()
  {
    return this.platforms.values();
  }


  getSectorAll (sector)
  {
    let collection = [];

    for (const zone of this.zones.values())
    {
      if (zone.getCass().getSector() === sector)
      {
        collection.push(zone);
      }
    }

    return collection;
  }


}
